var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.009 10.5C14.215 10.5 16.009 8.706 16.009 6.5C16.009 4.294 14.215 2.5 12.009 2.5C9.80303 2.5 8.00903 4.294 8.00903 6.5C8.00903 8.706 9.80303 10.5 12.009 10.5ZM12.009 3.5C13.663 3.5 15.009 4.846 15.009 6.5C15.009 8.154 13.663 9.5 12.009 9.5C10.355 9.5 9.00903 8.154 9.00903 6.5C9.00903 4.846 10.354 3.5 12.009 3.5ZM14 12.5H10C5.94 12.5 4.5 15.473 4.5 18.019C4.5 20.296 5.71105 21.5 8.00305 21.5H15.9969C18.2889 21.5 19.5 20.296 19.5 18.019C19.5 15.473 18.06 12.5 14 12.5ZM15.9969 20.5H8.00305C6.27205 20.5 5.5 19.735 5.5 18.019C5.5 16.959 5.824 13.5 10 13.5H14C18.283 13.5 18.5 17.264 18.5 18.019C18.5 19.735 17.7289 20.5 15.9969 20.5Z",
    fill: "#E7D6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.348ba7ff78b471526e5899e5b60fd47a.svg";
export { ForwardRef as ReactComponent };